/**
 * Restricción temporal de menú por iderp (sin modificar permisos_puestos del puesto 88).
 * Valeria Monroy Silva (2548): ocultar nómina de equipo y organigramas; conservar MiNomina,
 * Peticion Horas Extras y Cambios de horario solicitados (puede aceptarlos o rechazarlos).
 */
export const IDERPS_RESTRICCION_NOMINA_RH = [2548]

const PATHS_OCULTAR_NOMINA_RH = [
  'HorasExtraEquipo',
  'ComentariosNomina',
  'EncargadasComisiones',
  'NominaTeachers',
  'AguinaldosSeguimiento',
  'OrganigramaV2',
  'OrganigramaJefe',
]

function quitarPathsDeItems (items, pathsOcultar) {
  if (!Array.isArray(items)) return []

  const resultado = []
  for (const item of items) {
    if (!item) continue

    if (Array.isArray(item.items) && item.items.length) {
      const anidados = quitarPathsDeItems(item.items, pathsOcultar)
      if (anidados.length) {
        resultado.push({ ...item, items: anidados })
      }
      continue
    }

    if (item.path && pathsOcultar.includes(item.path)) continue
    resultado.push(item)
  }

  return resultado
}

export function quitarRutasDelMenu (menu, paths) {
  const list = Array.isArray(menu) ? menu : []
  return list
    .map((top) => {
      const items = quitarPathsDeItems(top.items || [], paths)
      if (top.path && paths.includes(top.path)) {
        return { ...top, path: null, items }
      }
      return { ...top, items }
    })
    .filter((top) => {
      if (top.path && !paths.includes(top.path)) return true
      return Array.isArray(top.items) && top.items.length > 0
    })
}

export function aplicarRestriccionMenuPorUsuario (menu, iderp) {
  const id = Number(iderp)
  if (!IDERPS_RESTRICCION_NOMINA_RH.includes(id)) {
    return Array.isArray(menu) ? menu : []
  }
  return quitarRutasDelMenu(menu, PATHS_OCULTAR_NOMINA_RH)
}

/** Ticket 80704: Sofía Arias (626) y cuenta coordinación (2767) — Asignación de contactos (TW). */
export const IDERPS_ASIGNACION_CONTACTOS_TW = [626, 2767]

export function puedeAsignacionContactosTw (usuario) {
  const iderp = Number(usuario && usuario.iderp)
  return IDERPS_ASIGNACION_CONTACTOS_TW.includes(iderp)
}

/**
 * Admin finanzas (28): sistema bloqueado salvo tickets, validación de ingresos,
 * inscripciones, eliminación de adeudos y estado de cuenta. Solo filtra; no otorga permisos que no tenga el puesto.
 */
// Desbloqueado temporalmente. Para volver a bloquear: [28]
export const IDERPS_SOLO_SECCIONES = [
  // 28,
]
export const RUTA_DEFAULT_SOLO_SECCIONES = 'ValidarIngresos'

const RUTAS_PERMITIDAS_SOLO_SECCIONES = [
  'ValidarIngresos',
  'Inscripciones',
  'EliminacionAdeudos',
  'EstadoCuentasBanco',
  'EstadoCuentasBancoDetalles',
  'tickets',
  'mistickets',
  'TicketsAsignados',
  'ticketarea',
  'ticketauxi',
  'addticket',
  'responderusuario',
  'verhistorialticketusuario',
  'agregarticketrp',
  'Home',
  'Login',
  'Perfil',
]

export function estaRestringidoSoloSecciones (iderp) {
  return IDERPS_SOLO_SECCIONES.includes(Number(iderp))
}

export function rutaPermitidaSoloSecciones (nombreRuta) {
  return !!nombreRuta && RUTAS_PERMITIDAS_SOLO_SECCIONES.includes(nombreRuta)
}

function dejarPathsEnItems (items, paths) {
  if (!Array.isArray(items)) return []

  const resultado = []
  for (const item of items) {
    if (!item) continue

    if (Array.isArray(item.items) && item.items.length) {
      const anidados = dejarPathsEnItems(item.items, paths)
      if (anidados.length) {
        resultado.push({ ...item, items: anidados })
      }
      continue
    }

    if (item.path && paths.includes(item.path)) resultado.push(item)
  }

  return resultado
}

export function filtrarMenuSoloSecciones (menu, iderp) {
  const list = Array.isArray(menu) ? menu : []
  if (!estaRestringidoSoloSecciones(iderp)) return list
  return list
    .map((top) => ({ ...top, items: dejarPathsEnItems(top.items || [], RUTAS_PERMITIDAS_SOLO_SECCIONES) }))
    .filter((top) => {
      if (top.path && RUTAS_PERMITIDAS_SOLO_SECCIONES.includes(top.path)) return true
      return top.items.length > 0
    })
}

/** Plantillas WhatsApp: del puesto Encargada de sucursal (18) solo Sofía Arias (626). */
export function aplicarRestriccionPlantillas (menu, usuario) {
  const puesto = Number(usuario && usuario.idpuesto)
  const iderp = Number(usuario && usuario.iderp)
  if ((puesto === 18 && iderp === 626) || puesto !== 18) return Array.isArray(menu) ? menu : []
  return quitarRutasDelMenu(menu, ['PlantillasTwilio'])
}
